module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MaterialCenterView.js"));
	}, "MaterialCenterView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialCenterView!./src/pages/Promote/MaterialCenter/MaterialCenterView.js
// module id = 1121
// module chunks = 431